<template>
  <div class="space-y-4">
    <div class="flex justify-between items-center">
      <h1 class="text-2xl font-semibold mr-auto">Email Templates</h1>
      <Button
        label="New Template"
        icon="pi pi-plus"
        @click="router.push('/crm/email-templates/new')"
      />
    </div>

    <DataTable :value="templates" dataKey="id" :loading="loading">
      <Column field="name" header="Name" />
      <Column field="subject" header="Subject" />
      <Column header="Actions">
        <template #body="slotProps">
          <div class="flex gap-2">
            <Button
              label="Edit"
              severity="secondary"
              @click="router.push(`/crm/email-templates/${slotProps.data.id}`)"
            />
            <Button
              icon="pi pi-trash"
              severity="danger"
              @click="confirmDelete(slotProps.data.id)"
            />
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useEmailTemplateStore } from '@/stores/emailTemplateStore'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

const router = useRouter()
const store = useEmailTemplateStore()

const templates = computed(() => store.items)
const loading = computed(() => store.loading)

onMounted(() => {
  store.load()
})

function confirmDelete(id: string) {
  if (confirm('Are you sure you want to delete this template?')) {
    store.remove(id)
  }
}
</script>
